import { TrackingActionSource } from './types';

export const getEventActionSource = (
    event?: React.MouseEvent | React.KeyboardEvent
): keyof typeof TrackingActionSource => {
    if (event) {
        const nativeEvent = event?.nativeEvent;
        if ('pointerType' in nativeEvent) {
            const pointerType = (nativeEvent as PointerEvent).pointerType;
            if (pointerType === 'mouse') {
                return 'Mouse';
            } else if (pointerType === 'touch') {
                return 'Touch';
            } else if (pointerType === 'pen') {
                return 'Pen';
            } else if (pointerType === '') {
                return 'Keyboard';
            }
        } else {
            // Likely from keyboard
            return 'Keyboard';
        }
    }
    return '';
};
